import httpClient from '@/http-client'
export const get = (Options = {}) => {
  return httpClient
    .get('/api/v1/restaurant-sales/product-price-schema', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const store = data => {
  return httpClient
    .post('/api/v1/restaurant-sales/product-price-schema', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const product = (Option = {}) => {
  return httpClient
    .get('/api/v1/restaurant-sales/product-price-schema/product', Option)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const productSaleCode = (Option = {}) => {
  return httpClient
    .get(
      '/api/v1/restaurant-sales/product-price-schema/product-sale-code',
      Option
    )
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const guestLevel = (Option = {}) => {
  return httpClient
    .get('/api/v1/restaurant-sales/product-price-schema/guest-levels', Option)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const update = (id, data) => {
  return httpClient
    .put(`/api/v1/restaurant-sales/product-price-schema/${id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const destroy = id => {
  return httpClient
    .delete(`/api/v1/restaurant-sales/product-price-schema/${id}`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const category = (Options = {}) => {
  return httpClient
    .get('/api/v1/restaurant-sales/product-price-schema/categories', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const group = (categoryId, Options = {}) => {
  return httpClient
    .get(
      `/api/v1/restaurant-sales/product-price-schema/groups/${categoryId}`,
      Options
    )
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export default {
  product,
  guestLevel,
  store,
  get,
  destroy,
  update,
  productSaleCode,
  category,
  group
}
